module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "splash"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('h1', {
    staticClass: "grey"
  }, [_vm._v("#MYHONOR")]), _vm._v(" "), _c('h1', {
    staticClass: "white"
  }, [_vm._v("COMMUNITY")]), _vm._v(" "), _c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.scrollTo('community')
      }
    }
  }, [_vm._v("See Instagrams")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://www.instagram.com/lisatellbe/",
      "target": "_blank"
    }
  }, [_c('p', {
    staticClass: "iglink-one"
  }, [_vm._v("@lisatellbe")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://www.instagram.com/johnnyedlind/",
      "target": "_blank"
    }
  }, [_c('p', {
    staticClass: "iglink-two"
  }, [_vm._v("@johnnyedlind")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5684744e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Splash.vue
// module id = 228
// module chunks = 1